
import { useContext, useEffect, useState } from 'react';
import styles from './Fotter.module.css';
import MobiStyles from './FotterMobi.module.css';

import ConnUrls from '../Connections/ConnectURL';
import { Link } from 'react-router-dom';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import { MasterContext } from '../Contexts/Master_Context';

const Footer = (props) => {
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [mastercon, setMastercon] = useContext(MasterContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);

    useEffect(() => {
    }, []);

    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
    }, [mobiOrNot]);



    return (
        <>
            <div className={currnetStyle.wave}
                style={{ backgroundImage: `url('${ConnUrls.PermanentImages}/wave.png')` }}>
            </div>
            {!mobiOrNot ?
                <div className={currnetStyle.footerWrap}>
                    <div className={`${currnetStyle.footerMain} flexIt`}>

                        {/* <div className={`${currnetStyle.fotterMainHead} flex-0`}>נַפּוֹלִיאוֹן</div> */}
                        <div className={`${currnetStyle.fotterMainHead} flex-0`}>
                            <Link className={"noDecoration"} to="/">
                                {/* <div className={`${currnetStyle.websiteMainHead} flex-2 pointing`}>נַפּוֹלִיאוֹן</div> */}
                                {/* <div className={`${currnetStyle.websiteMainHead} flex-2 pointing`}>NAPOLEON</div> */}
                                <img className={currnetStyle.websiteLogoImg}
                                    src={`${ConnUrls.PermanentImages}/logonapoW.png`}
                                    alt="נפוליאון" />
                            </Link>
                        </div>
                        <div className={`${currnetStyle.footerInItemsWrap} flexIt flex-1`}>
                            {fotterItems.map((item, index) => {
                                return (
                                    <div key={index} className={`${currnetStyle.fotteritm} flex-1`}>
                                        <div className={`biger bold`}>
                                            {item.headr}
                                        </div>
                                        <div className={currnetStyle.inFotterBlock}>
                                            {item.items.map((inItem, inIndex) => (
                                                <div key={inIndex} className={currnetStyle.inFotterBlockItem}>
                                                    {inItem.catname}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                        <div className={`${currnetStyle.footerInItemsWrap} flexIt flex-1`}>
                            אפשרויות תשלום - ויזה, דיינרס, מאסטרקאד, אמריקן אקס</div>
                    </div>
                    <div className={currnetStyle.allRights}>
                        <a href='http://www.ashdodmenu.co.il'>website by ASHDODMENU</a>
                    </div>
                </div>
                :
                <div className={currnetStyle.footerWrap}>
                    <div className={`${currnetStyle.footerMain}`}>

                        {/* <div className={`${currnetStyle.fotterMainHead} flex-0`}>נַפּוֹלִיאוֹן</div> */}
                        <div className={`${currnetStyle.fotterMainHead}`}>
                            <Link className={"noDecoration"} to="/">
                                {/* <div className={`${currnetStyle.websiteMainHead} flex-2 pointing`}>נַפּוֹלִיאוֹן</div> */}
                                {/* <div className={`${currnetStyle.websiteMainHead} flex-2 pointing`}>NAPOLEON</div> */}
                                <img className={currnetStyle.websiteLogoImg}
                                    src={`${ConnUrls.PermanentImages}/fotterLogo.png`}
                                    alt="נפוליאון" />
                            </Link>
                        </div>
                        <div className={`${currnetStyle.footerInSocials} centerByMargin`}>
                            {
                                mastercon?.socialMds.map((item, index) => {
                                    const socialNames = ["פייסבוק", "אינסטגרם", "וואטסאפ"];
                                    return (
                                        <div key={index} className={"tblcell"}>
                                            <a href={item.url} target='_blank'>
                                                <div className={`${currnetStyle.socialIcon} spaceMargeRight_10`}>
                                                    <img src={`${ConnUrls.servMediasUrl}${item.src}`} alt={socialNames[index] || "רשת חברתית"} />
                                                </div>
                                            </a>
                                        </div>
                                    );
                                })
                            }
                        </div>


                        <div className={`${currnetStyle.footerInSocials} centerByMargin`}>
                            <div className={"tblcell"}>
                                <div className={currnetStyle.fotterTxt}>כל הזכויות שמורות לנפוליאון</div>
                            </div>
                        </div>

                        <div className={`${currnetStyle.footerInSocials} centerByMargin`}>
                            <div className={"tblcell"}>
                                <img className={currnetStyle.paytypes}
                                    src={`${ConnUrls.PermanentImages}/paytypes.png`}
                                    alt="אמצעי תשלום" />
                            </div>
                        </div>

                    </div >
                    <div className={currnetStyle.allRights}>
                        <a href='http://www.ashdodmenu.co.il'>website by ASHDODMENU</a>
                    </div>
                </div >


            }
        </>
    );
}

export default Footer;

const fotterItems = [
    {
        headr: "מגשי אירוח",
        items: [
            {
                catname: "סלטים",
                lnk: ""
            },
            {
                catname: "מאפים",
                lnk: ""
            },
            {
                catname: "כריכים",
                lnk: ""
            },
            {
                catname: "פסטות",
                lnk: ""
            },
            {
                catname: "דגים",
                lnk: ""
            }
        ]
    },
    {
        headr: "מידע כללי",
        items: [
            {
                catname: "אודות",
                lnk: ""
            },
            {
                catname: "תקנון",
                lnk: ""
            },
            {
                catname: "תעודת כשרות",
                lnk: ""
            }
        ]
    },
    {
        headr: "יצירת קשר",
        items: [
            {
                catname: "וואטסאפ",
                lnk: ""
            },
            {
                catname: "פייסבוק",
                lnk: ""
            },
            {
                catname: "אינסטגרם",
                lnk: ""
            },
            {
                catname: "052-3118686",
                lnk: ""
            }
        ]
    }

]
